import { useListBookingRequests } from '@cocoonspace/sdk-js/v2/domains/schedulers/schedulers'
import { useLingui } from '@lingui/react/macro'

import { BookingCard } from '~/domains/scheduling/bookings/booking-card'

const useBookingRequestsToTreat = () => {
	return useListBookingRequests(
		{ status: 'pending' },
		{ query: { select: ({ data }) => data } },
	)
}

export const BookingRequests = () => {
	const { t } = useLingui()
	const { data: bookingRequests } = useBookingRequestsToTreat()
	const hasBookings = !!bookingRequests?.length
	if (!hasBookings) return null

	return (
		<div className='flex flex-col gap-4'>
			<h2 className='text-3xl font-bold'>{t`Mes rendez-vous à traiter`}</h2>

			<div className='grid grid-cols-1 gap-4 md:grid-cols-3'>
				{bookingRequests?.map((br) => (
					<BookingCard
						key={br.id}
						bookingRequest={br}
					/>
				))}
			</div>
		</div>
	)
}
